import { cacheKeys } from "@constants/cache-keys";
import { useQuery } from "@tanstack/react-query";
import { getMixedItemDistribution } from "api/queries";
import useAppConfigIds from "./useAppConfigIds";
import { useDemoExamStore } from "./useDemoExamStore";

const useMixedItemDist = (enabled = true) => {
	const { collectionId, userId } = useAppConfigIds();
	const demoExam = useDemoExamStore((state) => state.currentExam);

	const { data, isLoading, isRefetching, dataUpdatedAt } = useQuery({
		queryKey: [cacheKeys.home, userId, collectionId, demoExam.id],
		queryFn: () =>
			getMixedItemDistribution({
				userPublicMetadataId: userId,
				examId: String(collectionId),
				action: "COMMON_DISTRIBUTION",
			}),
		enabled: !!collectionId && !!userId && enabled,
	});

	return { data, isLoading, isRefetching, dataUpdatedAt };
};

export default useMixedItemDist;
